// extracted by mini-css-extract-plugin
module.exports = {"dciContainer":"F-dci-gauge-dci-container-1VxA4","tooltipContent":"F-dci-gauge-tooltip-content-2m2kd","value":"F-dci-gauge-value-1J73u","legend":"F-dci-gauge-legend-1Pz0J"};